import { render, staticRenderFns } from "./FallbackPage.vue?vue&type=template&id=7c2b56cb&"
import script from "./FallbackPage.vue?vue&type=script&lang=js&"
export * from "./FallbackPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports